import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { RoleV2 } from '../../../types/role';
import { MobileCardActions, MobileStat } from '../components/MobileCardParts';

interface MobileRoleCardProps {
  role: RoleV2;
  onEdit: () => void;
  onDelete: () => void;
}

export const MobileRoleCard = memo(function MobileRoleCard({
  role,
  onEdit,
  onDelete,
}: MobileRoleCardProps) {
  const { t } = useTranslation();

  return (
    <div className="mobile-station-card">
      <div className="mobile-card-header">
        <div style={{ flex: 1, minWidth: 0 }}>
          <span className="mobile-card-id-label">
            <span
              className="material-symbols-outlined"
              style={{
                fontSize: '0.875rem',
                marginRight: '0.25rem',
                verticalAlign: 'middle',
              }}
              aria-hidden="true"
            >
              shield_person
            </span>
            {t('dashboard.roles.role')}
          </span>
          <h3
            className="mobile-card-id-value"
            style={{
              fontSize: '0.9375rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: '0.375rem',
            }}
          >
            {role.isBuiltIn && (
              <span
                className="material-symbols-outlined"
                style={{ fontSize: 14, color: '#9ca3af' }}
                aria-hidden="true"
              >
                lock
              </span>
            )}
            {role.name}
          </h3>
        </div>
        <span
          className={`mobile-status-badge ${
            role.isBuiltIn ? 'role-badge-system' : ''
          }`}
        >
          {role.isBuiltIn
            ? t('dashboard.roles.builtIn')
            : t('dashboard.roles.custom')}
        </span>
      </div>

      <div className="mobile-card-stats mobile-card-stats-2x2">
        <MobileStat
          icon="key"
          label={t('dashboard.tables.roles.permissions')}
          value={role.permissions.length}
        />
        <MobileStat
          icon="group"
          label={t('dashboard.tables.roles.users')}
          value={role.userCount}
        />
      </div>

      <MobileCardActions
        editLabel={t('dashboard.roles.edit')}
        deleteLabel={t('dashboard.common.delete')}
        onEdit={onEdit}
        onDelete={onDelete}
        deleteDisabled={role.isBuiltIn}
      />
    </div>
  );
});

export default MobileRoleCard;
